


















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ScrollObject } from '@/models/HorizontalContentScroller';
import { UpSellListItem } from '@/models/Product';
import ResponsiveImage from '../ResponsiveImage.vue';
import { CheckoutStore } from '@/store/checkoutstate';
import { AddOrUpdateCartItem } from '@/models/Cart/Cart';
import PriceDisplay from '../SimulatorSummary/PriceDispay.vue';

@Component({
    components: {
        ResponsiveImage,
        PriceDisplay
    }
})
export default class UpSellProductListing extends Vue {
    [x: string]: any;
    @Prop() products!: UpSellListItem[];
    //content!: Content;
    //title!: string;
    scrollStartPosition: number = 0;
    scrollEndPosition: number = 1000;
    scrollObject: ScrollObject = {
        ViewWidth: 1000,
        Gap: 10,
        Position: 0,
        Width: 500,
        Id: '',
        Target: 0,
        ScrollWidth: 0
    };
    eventListenersSet: Boolean = false;
    isTouchDevice: Boolean = false;
    compInstance: number = 0;

    constructor() {
        super();
    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    mounted() {
        if (this.$vnode.componentInstance) {
            this.compInstance = (this.$vnode.componentInstance as any)._uid;
        }
        setTimeout(this.setScrollObject, 1000);
        this.setScrollObject();
    }

    isNextActive() {
        return Math.abs(this.scrollObject.Position - this.scrollObject.Width) > 2;
    }
    isBackActive() {
        return this.scrollObject.Position !== 0;
    }

    handleScroll(event: any) {
        this.setScrollObject();
    }

    noLazyLoad(image: string) {
        if (image != null) {
            return image.replace('lazyload', '');
        }

        return '';
    }

    public addToCart(product: UpSellListItem): void {
        //this.spinner.spin(this.$el.querySelector('.buy-button') as HTMLElement);
        //console.log('Spinner start');
        const payload: AddOrUpdateCartItem = {
            articleNumber: product.id.toString(),
            quantity: 1,
            rowSystemId: product.id.toString(),
            comment: '',
            type: ''
        };

        CheckoutStore.addState(payload).then(() => {
            // this.quantity = 1;
            this.spinner.stop();
            //console.log('Spinner stop');
        });
    }

    setScrollObject() {
        // @ts-ignore
        const scrollObject: ScrollObject = {};
        const ul = document.querySelector('#scroll-list');

        if (ul != null) {
            const styles = window.getComputedStyle(ul);
            const columnGap = Number(styles.getPropertyValue('grid-column-gap').replace('px', ''));
            scrollObject.Gap = columnGap;
            // @ts-ignore
            scrollObject.Width = ul.scrollWidth - ul.offsetWidth;
            // @ts-ignore
            scrollObject.ViewWidth = ul.offsetWidth;
            scrollObject.Position = ul.scrollLeft;
            scrollObject.ScrollWidth = ul.scrollWidth;
            scrollObject.Target = this.scrollObject.Target;
        }

        this.scrollObject = scrollObject;
    }

    scroll(ev: PointerEvent, adjust: number) {
        this.setScrollObject();
        const el = ev.target as HTMLElement;
        const parent = el.closest('.product-listing');
        if (parent) {
            const ul = parent.querySelector('ul.tab-container');
            if (ul != null) {
                this.scrollObject.Target =
                    this.scrollObject.Position + (this.scrollObject.ViewWidth + this.scrollObject.Gap) * adjust;
                ul.scrollTo({
                    left: this.scrollObject.Target,
                    behavior: 'smooth'
                });

                // @ts-ignore
                ul.onscroll = e => {
                    if (
                        ul != null &&
                        (ul.scrollLeft === this.scrollObject.Target || ul.scrollLeft === this.scrollObject.Width)
                    ) {
                        this.setScrollObject();
                        // @ts-ignore
                        ul.onscroll = null;
                    }
                };
            }
        }
    }
}
